import React from "react";
import MatchCard from "./MatchCard";
import SmallLoader from "../../SmallLoader";
import moment from "moment-timezone";

const Matches = (props) => {
    const {
        isMobile,
        loading,
        matches,
        fetchMatches,
        leagueId,
        matchDayId,
        isPredictionAllowed,
    } = props;

    const renderMobile = () => {
        return (
            <>
                {
                    loading ?
                        <SmallLoader loading={loading}/>
                        :
                        <>
                            {
                                matches?.map((matchDay, index)=>(
                                    <div key={index} className={"d-flex flex-column gap-3"}>
                                        <div className={"text-skins-teal font-15 fw-700 cabin"}>{moment(matchDay?.date).format("dddd | DD MMMM YYYY")}</div>
                                        <div className={"d-flex flex-column gap-3 w-100 mb-3"}>
                                            {
                                                matchDay?.matches?.map((match, index)=>(
                                                    <MatchCard
                                                        key={index}
                                                        isMobile={isMobile}
                                                        match={match}
                                                        fetchMatches={fetchMatches}
                                                        leagueId={leagueId}
                                                        matchDayId={matchDayId}
                                                        isPredictionAllowed={isPredictionAllowed}
                                                    />
                                                ))
                                            }

                                        </div>
                                    </div>
                                ))
                            }

                        </>
                }
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                {
                    loading ?
                        <SmallLoader loading={loading}/>
                        :
                        <>
                            {
                                matches?.map((matchDay, index)=>(
                                    <div key={index} className={"d-flex flex-column gap-3"}>
                                        <div className={"text-white font-20 fw-700 cabin"}>{moment(matchDay?.date).format("dddd | DD MMMM YYYY")}</div>
                                        <div className={"d-flex flex-column gap-3 w-100 mb-3"}>
                                            {
                                                matchDay?.matches?.map((match, index)=>(
                                                        <MatchCard
                                                            key={index}
                                                            isMobile={isMobile}
                                                            match={match}
                                                            fetchMatches={fetchMatches}
                                                            leagueId={leagueId}
                                                            matchDayId={matchDayId}
                                                            isPredictionAllowed={isPredictionAllowed}
                                                        />
                                                ))
                                            }

                                        </div>
                                    </div>
                                ))
                            }

                        </>
                }
            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default Matches;
